import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import DimmerComponent from "../../Dashboard/DimmerComponent";
import { ReactComponent as MoreOptions } from "../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import ChartName from "../../Dashboard/Charts/ChartName";
import FBPageSelector from "../FBPageSelector";
import DeleteWidget from "../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../Dashboard/Charts/ChartFilterOptions";
import "../../EnhancedInsights/modules/TwitterInsights/components/RecentPosts/RecentPosts.scss";
import { ReactComponent as MiniMize } from "../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import FbPost from "./FbPost";
import Loading from "../../EnhancedInsights/modules/InstagramInsights/components/Loading/Loading";
import CustomDropdown from "../../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";
import "./FbRecentPosts.scss";

function FbRecentPosts(props) {
    const [downloading, setDownloading] = useState(false);

    // const [activateRef, setActivateRef] = useState(false);
    const carouselRef = useRef(null);
    const chartEl = useRef();
    const [currentScroll, setCurrentScroll] = useState(0);

    let nodata = props.pageStatus || props.data?.recentPosts?.length === 0;

    const totalData = props.data?.recentPosts;

    // useEffect(() => {
    //     setActivateRef(true);

    //     return () => {
    //         setActivateRef(false);
    //     };
    // }, []);

    const nextPage = () => {
        carouselRef.current.scrollBy({
            left: carouselRef.current.clientWidth,
            behavior: "smooth",
        });
        setCurrentScroll(currentScroll + 1);
    };

    const previousPage = () => {
        carouselRef.current.scrollBy({
            left: -carouselRef.current.clientWidth,
            behavior: "smooth",
        });
        setCurrentScroll(currentScroll - 1);
    };

    const increment = () => {
        if (props.fbSelectedPageIds.length === 1) return;
        let index;
        props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === props.selectedFbPage?.value) index = ind;
        });
        if (index === props.fbSelectedPageIds.length - 1) props.setSelectedFbPage(props.fbSelectedPageIds[0]);
        else props.setSelectedFbPage(props.fbSelectedPageIds[index + 1]);
    };

    const decrement = () => {
        if (props.fbSelectedPageIds.length === 1) return;
        let index;
        props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === props.selectedFbPage?.value) index = ind;
        });
        if (index === 0) props.setSelectedFbPage(props.fbSelectedPageIds[props.fbSelectedPageIds.length - 1]);
        else props.setSelectedFbPage(props.fbSelectedPageIds[index - 1]);
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    isFacebook
                    isFBPage={props.isFBPage}
                    name={props.widget?.name || "Recent Posts"}
                    info="This section show posts based on the sorting options selected in the widget."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isFBPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}
                    {/* {!props.isPublic && !props.isResearchDashboard && <>{renderDownloadButton(nodata)}</>} */}

                    {(props.isPublic && nodata) || props.isFBPage ? null : (
                        <Popup
                            className="skiptranslate"
                            trigger={
                                props.expand ? (
                                    <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                ) : (
                                    <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                )
                            }
                            inverted
                            content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                            size="mini"
                            position="bottom center"
                            style={{ zIndex: "99999" }}
                        />
                    )}

                    {!props.isPublic && <MoreOptions className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!nodata && (
                        <>
                            <CustomDropdown
                                className="interval-selector"
                                name="Sort By"
                                options={props.postOrderByList}
                                value={props.postOrderBy}
                                onChange={props.changePostOrderBy}
                            />
                        </>
                    )}
                    {!props.isFBPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isFBPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}

            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                {!props.isFBPage && (
                    <div data-html2canvas-ignore="true" className={`chart-slider chart-slider-left ${props.fbSelectedPageIds?.length === 1 ? "disabled" : ""}`}>
                        <ArrowIcon onClick={decrement} />
                    </div>
                )}
                <div className="chart-area">
                    {!props.isFBPage && props.selectedFbPage && (
                        <FBPageSelector
                            selectedFbPage={props.selectedFbPage}
                            setSelectedFbPage={props.setSelectedFbPage}
                            fbSelectedPageIds={props.fbSelectedPageIds}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    {!nodata && !downloading && props.selectedFbPage && !props.loading ? (
                        <div className="recentPosts">
                            {props.isFBPage && totalData?.length > 3 && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )}
                            {!props.isFBPage && totalData?.length > 1 && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )}
                            {/* {carouselRef.current?.scrollWidth > carouselRef.current?.clientWidth && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )} */}

                            <div className="carousel" ref={carouselRef}>
                                {totalData?.map((post, index) => (
                                    <FbPost key={index} data={post} />
                                ))}
                            </div>

                            {/* {carouselRef.current?.scrollWidth > carouselRef.current?.clientWidth && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )} */}

                            {props.isFBPage && totalData?.length > 3 && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )}
                            {!props.isFBPage && totalData?.length > 1 && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )}
                        </div>
                    ) : downloading || !props.selectedFbPage || props.loading ? (
                        <Loading />
                    ) : (
                        <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                    )}
                </div>
                {!props.isFBPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.fbSelectedPageIds?.length === 1 ? "disabled" : ""}`}>
                        <ArrowIcon onClick={increment} />
                    </div>
                )}
            </div>
        </>
    );

    return props.isFBPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default FbRecentPosts;
